import { getLocale } from "@/data/regionInfo";

export default {
  data() {
    return {
      selectedModelName: null,
      selectedRecipeData: null,
      newPalette: null,
      oldPalette: null
    };
  },
  computed: {
    isApparel() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    translations(){
      return this.$store.state.translations.data;
    },
    prices() {
      return this.$store.state.transferDesign.prices;
    },
    recipes() {
      const allRecipes = this.$store.state.transferDesign.recipes;
      const currentModel = this.$store.state.utils.pdmModel;
      if (allRecipes[currentModel]) delete allRecipes[currentModel];
      if (this.$recipe.checkForPersonalization()) {
        const { personalization: { max_character_length } } = this.configuration;
        const personalizationComponent = this.$recipe.getPersonalizationComponentName();
        let data = this.$store.state.recipe.recipe_v2.components[personalizationComponent].personalization ?? '';
        for (let modelName in allRecipes) {
          let maxCharacters = max_character_length[modelName] || max_character_length['default'];
          const isTwoModelsEmbroidery = data.length > 1;
          const longestEmbroideryText = !isTwoModelsEmbroidery ? data[0].text.length :
           data[1].text.length > data[0].text.length ? data[1].text.length : data[0].text.length;
          if (longestEmbroideryText > maxCharacters) {
            allRecipes[modelName]['isPersonalizationInvalid'] = true;
          }
        }
      }
      return allRecipes;
    },
    isOverMaxLength() {
      return Object.keys(this.recipes).length > 4 &&
        !this.$store.getters['utils/returnScreenSize'].includes('mobile');
    },
    configuration() {
      return this.$store.state.utils.configuration;
    }
  },
  methods: {
    isSelected(modelName) {
      return this.selectedModelName === modelName;
    },
    onSelect(modelName, recipeData) {
      this.$customizerDataLayer.logAnalyticsEvent({
        type: this.$customizerDataLayer.types.customizerTransferDesignSelectStyle,
        eventLabel: recipeData.displayName,
        forceEcomDataLayerFormat: true,
      });
      this.selectedModelName = modelName;
      this.selectedRecipeData = recipeData.recipe_v2;
      this.$emit('blockCtaPrimaryButton', false);
      if(this.configuration?.enableTransferDesignConfigPalettes || this.isApparel) {
        this.getDifferentPalette();
      }
    },
    onContinue() {
      if(!this.selectedRecipeData && this.configuration.modals?.transferDesign) {
        return this.$emit('showToolTip', true);
      }
      if(this.newPalette) {
        this.updatePalettes();
      }
      return new Promise((resolve, reject) => {
        this.$store.dispatch("recipe/SAVE_RECIPE", {
          recipe: this.selectedRecipeData,
          requestParams: { locale: getLocale() }
        })
        .then((data) => {
          const recipeId = data.recipeId;
          const { recipe_v2 } = this.$store.state.recipe;

          this.selectedRecipeData.recipeId = recipeId;
          this.$customizerDataLayer.logAnalyticsEvent({
            type: this.$customizerDataLayer.types.customizerTransferDesign,
            eventLabel: 'Finish',
            forceEcomDataLayerFormat: true,
          });

          // reset tabs propertiesInit in order for the tabs data to reset
          this.$eventBus.$emit("resetPropertiesInit");
          // set deco stitch to false if it was applied
          if(this.$store.state.geometryUpdates.decostitchApplied)
            this.$store.commit("geometryUpdates/SET_DECOSTITCH_APPLIED", false);

          // Validates if the personalization object is valid for the
          // transferred design
          if (this.$recipe.checkForPersonalization()) {
            const { personalization: { max_character_length } } = this.configuration
            const maxCharacters = max_character_length[this.selectedModelName] || max_character_length['default'];
            // This is needed since at this point the new pdm has not beeen loaded
            const personalizationComponent = this.$recipe.getPersonalizationComponentName();
            for (let item of recipe_v2.components[personalizationComponent].personalization){
              if (item.text.length > maxCharacters) {
                this.$store.commit('transferDesign/SET_IS_PERSONALIZATION_INVALID', true);
                break;
              }
            }
          }
          // sets the data that will be used to load the selected
          // recipe before asking to load the new model
          this.$store.commit('transferDesign/SET_DESIGN_DATA', {
            modelName: this.selectedModelName,
            designData: this.selectedRecipeData,
          });

          // changes the step in the parent component
          this.$emit("continue");

          // removes the close and continue buttons
          this.$emit('showCtaPrimaryButton', false);
          this.$emit('showCloseIcon', false);

          // applies the new model
          this.$store.commit('utils/SET_PDM_MODEL', this.$store.state.transferDesign.modelName);
          this.$eventBus.$emit("navigationActivateUpdatedFlag");
          // Reset the Undo state to default
          this.$store.commit("undo/CLEAN_UNDO");
          if(this.isApparel) {
            this.$store.commit("graphicsController/CLEAR_PLACEMENT_SETTING");
          }

          this.$store.commit('ugc/tempData/SET_RECIPE', recipe_v2);

          if (this.$store.getters["recipe/getImageLibComponentsName"].length > 0) {
            this.$store.commit("imageGallery/SET_LIBRARY_RECIPE", recipe_v2);
          }

          this.$store.commit('utils/SET_IS_FINISH_MY_DESIGN_APPLIED', false);

          if(this.isApparel) this.$store.commit('gdm/CLEAR_CONFIG_STATE_IN_TRANSFER_DESIGN');

          resolve();
        })
        .catch(err => {
          console.error(err);
          reject(err);
        });
      });
    },
    getNewPalettes() {
      let newPalettesId = [];
      if (this.configuration?.enableTransferDesignConfigPalettes && this.configuration?.default_palettes?.[this.selectedModelName] && this.selectedRecipeData?.palettes){
        newPalettesId = [...this.configuration?.default_palettes?.[this.selectedModelName], ...this.selectedRecipeData?.palettes]
      } else {
        newPalettesId = !this.configuration?.enableTransferDesignConfigPalettes ? this.selectedRecipeData?.palettes : (this.configuration?.default_palettes?.[this.selectedModelName] || this.selectedRecipeData?.palettes);
      }
      return newPalettesId || [];
    },
    getDifferentPalette() {
      const storePalettes = this.$store.state.swatches.palettesId;
      const newPalettesId = this.getNewPalettes();
      const storePalettesSet = new Set(storePalettes);
      const paletteToRemoveSet = new Set(newPalettesId);
      const diff = storePalettes?.filter(id => !paletteToRemoveSet.has(id))
        .concat(newPalettesId?.filter(id => !storePalettesSet.has(id)));

      if(diff.length) {
        this.newPalette = diff?.filter(item => !storePalettesSet.has(item));
        this.oldPalette = diff?.filter(item => !paletteToRemoveSet.has(item));
      }
    },
    async updatePalettes() {
      this.oldPalette.forEach(data  => {
          this.$store.commit("swatches/REMOVE_PALETTE",data);
        }
      )
      const promises = [];
      this.newPalette.forEach(data  => {
        promises.push(this.$store.dispatch("swatches/GET_PALETTES", data));
      });
      Promise.all(promises)
        .then(() => {
          this.$store.commit("swatches/UPDATE_PALETTES_ID", this.getNewPalettes() );
          this.$store.commit("swatches/RESET_PALETTES_BY_COMPONENT");
      });
    }
  },
  created() {
    this.$emit('showCtaPrimaryButton', true);
    this.$emit('showIconButton', true);
    this.$emit('blockCtaPrimaryButton', true);
    this.$emit('showCloseIcon', true);
  }
}